import React, { Component } from 'react';
import ValidatedCheckbox from '../ValidatedCheckbox/ValidatedCheckbox';

const Step5 = (props) => {
    return (
        <div>
            <h2>הצהרת סודיות</h2>
            <ol start="118">
<li>
<ol style={{listStyleType:'hebrew', direction:'RTL'}}>
<li>היה אדם בעל חוזה עם המדינה או עם גוף מבוקר כמשמעותו בחוק מבקר המדינה, התשי"ח - 1958 (נוסח משולב), ובחוזה יש התחייבות לשמור בסוד ידיעות שיגיעו אליו עקב ביצוע החוזה, והוא מסר, ללא סמכות כדין, ידיעה כאמור לאדם שלא היה מוסמך לקבלה, דינו - מאסר שנה אחת.</li>
<li>בסעיף זה, "בעל חוזה" - לרבות מי שהועסק, כעובד או כקבלן, לשם ביצוע החוזה; ואולם תהא זו הגנה טובה לנאשם לפי סעיף זה שלא ידע על ההתחייבות לשמור ידיעות כאמור בסוד ושהוא מסר את הידיעה בתום לב.</li>
</ol>
</li>
<li>
מי שנמסר לו מסמך רשמי בתנאי מפורש שעליו לשמרו בסוד, והוא מסרו לאדם שאינו מוסמך לקבלו, דינו - מאסר שנה אחת; התרשל בשמירתו או עשה מעשה  שיש בו כדי לסכן בטיחותו של המסמך, דינו - מאסר ששה חודשים.".
ידוע לי כי במסגרת השירותים הניתנים לצה"ל/משהב"ט יתכן ואיחשף למידע מסווג 
מידע צבאי/ביטחוני פנימי.
</li>
</ol>
<br/>
אני מתחייב שלא למסור או לחשוף כל מידע שהגיע אליי במסגרת אספקת השירות לצה"ל/משהב"ט לכל גורם שהוא, לרבות לספק, ללא אישור מוקדם של קצין ביטחון / ממונה ביטחון מטעם צה"ל / משהב"ט.
ידוע לי כי האמור יחול הן בנוגע למידע שיגיע אלי במסגרת השירותים הניתנים על-ידי לצה"ל/משהב"ט והן בנוגע למידע שיגיע אלי באקראי.
              <br/>
              <br/>
              <ValidatedCheckbox name="isApproveConfidentiality" label="הריני לאשר כי קראתי את סעיפים 118 ו- 119 לחוק העונשין, התשלז - 1977, וכי נהירות לי חובותי מכח סעיפים אלו" validated={true} tabIndex="1"/>
        </div>
    );
  };
  
  export default Step5;